export default __webpack_public_path__ + "static/media/InvoiceInactive.e89be213.svg";